import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { AlertHistory } from "@/models/AlertHistory";
import { computed, ref } from "vue";

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  props: {
  alertID: { type: String, required: true },
},
  setup(__props) {

const props = __props


const contentPlain = computed(() => {
  return alertHistory.value?.content;
});
const showPlain = computed(() => contentRich.value == undefined)
const contentRich = computed(() => {
  return alertHistory.value?.richContent;
});
const alertHistory = ref<AlertHistory>();

const fetchAlertHistory = async () => {
  alertHistory.value = await AlertHistory.fetchByAlertID(props.alertID);
};

fetchAlertHistory();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showPlain))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(contentPlain)), 1))
      : _createCommentVNode("", true),
    (_unref(contentRich))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: _unref(contentRich)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})